var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M477.83,34.17c-22-22-51.77-27.5-71.48-16-56.07,32.67-172.53-50.52-305.63,82.58S50.81,350.28,18.14,406.35c-11.47,19.71-6,49.5,16,71.48s51.77,27.5,71.48,16c56.07-32.66,172.53,50.53,305.63-82.57s49.91-249.56,82.58-305.63C505.33,85.94,499.82,56.15,477.83,34.17ZM233.09,341.05a23.2,23.2,0,0,1-23.2,23.19h-15a23.2,23.2,0,0,1-23.19-23.19V171a23.2,23.2,0,0,1,23.19-23.19h15A23.2,23.2,0,0,1,233.09,171Zm107.17,0a23.2,23.2,0,0,1-23.19,23.19h-15a23.2,23.2,0,0,1-23.2-23.19V171a23.2,23.2,0,0,1,23.2-23.19h15A23.2,23.2,0,0,1,340.26,171Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd55af4841d9837240f83c34456ce004.svg";
export { ForwardRef as ReactComponent };